export class WorkflowDefine {
    persistenceId?;
    createTime?;
    content?;
    name?;
    description?;
    status?;
    id?;
    version: number;
    bpmnContent?;
    code?;
    serviceCode?;
    isDeleted?;
    entityCode?;
}
